import { combineReducers } from "redux";
import eventsReducer from "./events";
import typesReducer from "./types";
// import bugsReducer from "./bugs";
// import projectsReducer from "./projects";
// import usersReducer from "./users";

export default combineReducers({
  events: eventsReducer,
  types: typesReducer,
  // users: usersReducer,
});
